import type React from 'react'
import type { ReactNode } from 'react'

import type { TooltipProps } from '@mui/material'
import type { DivProps } from 'commons/types/htmlElements'
import { Icon, Tooltip } from 'components'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

export interface InfoProps extends DivProps {
  children: ReactNode | string
  iconSize?: number
  placement?: TooltipProps['placement']
}

export const Info: React.FC<InfoProps> = ({
  children,
  iconSize = 20,
  placement = 'top',
  ...rest
}) => {
  return (
    <S.InfoContainer {...rest}>
      <Tooltip
        arrow
        disableFocusListener
        placement={placement}
        title={<S.InfoContent>{children}</S.InfoContent>}
      >
        <S.IconContainer>
          <Icon color={theme.colors.primary.main} icon="info" size={`${iconSize}`} />
        </S.IconContainer>
      </Tooltip>
    </S.InfoContainer>
  )
}
